import { Injectable, inject } from '@angular/core';
import ServiceRestServices from '../services/service-rest.service';
import Session from '../utils/session.service';
import Time from '../utils/timer.service';
import Config from '../utils/config.service';
import NotificationService from '../services/notification.service';
import AngularHelperService from '../services/angular-helper.service';
import AngularFilterHelperService from '../services/angular-filter-helper.service';
import AngularRoutingHelperService from '../services/angular-routing-helper.service';
import AngularBroadcastHelperService from '../services/angular-broadcast-helper.service';
import AngularStateHelperService from '../services/angular-state-helper.service';

@Injectable({ providedIn: 'root' })
export default class BookingsService {
	private serviceRestServices: ServiceRestServices = inject(ServiceRestServices);
	private session: Session = inject(Session);
	private time: Time = inject(Time);
	private config: Config = inject(Config);
	private notificationService: NotificationService = inject(NotificationService);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
	private angularRoutingHelperService: AngularRoutingHelperService = inject(AngularRoutingHelperService);
	private angularBroadcastHelperService: AngularBroadcastHelperService = inject(AngularBroadcastHelperService);
	private angularStateHelperService: AngularStateHelperService = inject(AngularStateHelperService);
	
	store: any = {
		CONFIRMED: [],
		PAYED: [],
		REQUESTS: [],
		lastIds: {}
	};
	
	constructor() {
		this.initPolling();
	}
	
	initPolling() {
		this.angularBroadcastHelperService.onRootEvent(this.config.getBroadcastConfig().Session.LOGIN, (event, data) => {
			var session: any = this.angularStateHelperService.getGlobalProperty('session');
			this.pollBookings(session.user);
			this.time.newTimer('UNCONFIRMED_BOOKINGS_POLLING_TIMER', () => { this.pollBookings(); }, 5000);
		});
	}
	
	pollBookings(user?) {
		user = user || (this.session.getSession() && this.session.getSession().user) || {};
		if (!user.id) return;
		
		if (user.businessUserType === 'SERVICE_PROVIDER') {
			this.fetchBookings({ status: 'PAYED' });
			this.fetchBookingRequests(user.service.id);
		} else {
			this.time.deleteTimer('UNCONFIRMED_BOOKINGS_POLLING_TIMER');
		}
	}
	
	confirm(booking) {
		var user: any = this.session.getSession() && this.session.getSession().user || {};
		if (!booking || !booking.id || !user || user.businessUserType !== 'SERVICE_PROVIDER') return;
		this.serviceRestServices.confirmBookingForBU({ id: booking.id }, () => {
			this.removeBooking(booking);
		});
	}
	
	decline(booking) {
		var user: any = this.session.getSession() && this.session.getSession().user || {};
		if (!booking || !booking.id || !user || user.businessUserType !== 'SERVICE_PROVIDER') return;
		this.serviceRestServices.declineBookingForBU({ id: booking.id, declineReason: booking.declineReason }, () => {
			this.removeBooking(booking);
		});
	}
	
	removeBooking(booking) {
		if (!booking || !booking.id) return;
		
		var arr: any = this.store[booking.status];
		if (!arr || !arr.length) return;
		
		var index: any = -1;
		for (var i = 0, len = arr.length; i < len; i++) {
			if (arr[i].id === booking.id) {
				index = i;
				break;
			}
		}
		if (index !== -1) arr.splice(index, 1);
	}
	
	fetchBookings(params) {
		var deferred: any = this.angularHelperService.getDeferredPromise();
		
		this.serviceRestServices.getBookings(params, (res) => {
			var status: any = params.status;
			if (status === 'PAYED') {
				var oldBookings: any = this.store[status] || [];
				var newBookings: any = res || [];
				
				if (newBookings.length > oldBookings.length) {
					this.store.lastIds[status] = newBookings.slice(-1).pop().id;
					var opts: any = {
						type: 'booking',
						lastId: this.store.lastIds[status],
						title: this.angularFilterHelperService.translate('Services.Other.New_Bookings'),
						body: this.angularFilterHelperService.translate('Services.Other.Proceed_To_Accept'),
						onClick: () => {
							this.angularRoutingHelperService.setPath('/bookings/unconfirmed');
						},
					};
					this.notificationService.displayPushNotification(opts);
				}
			}
			if (status) this.store[status] = res || [];
			deferred.resolve(res);
		});
		
		return deferred.promise;
	}
	
	getBookings(status) {
		if (!status || !this.store[status]) return [];
		return this.store[status];
	}
	fetchBookingRequests(businessServiceId) {
		const deferred = this.angularHelperService.getDeferredPromise();

		if (!businessServiceId) {
			deferred.resolve([]);
			return deferred.promise;
		}

		this.serviceRestServices.getBookingRequests(
			{ businessServiceId },
			(res) => {
				const newRequests = res || [];
				const oldRequests = this.store.REQUESTS || [];

				if (newRequests.length > oldRequests.length) {
					const last = newRequests.at(-1);
					this.store.lastIds.REQUESTS = last?.id;

					this.notificationService.displayPushNotification({
						type: 'request',
						lastId: last?.id,
						title: this.angularFilterHelperService.translate('Services.Other.New_Bookings'),
						body: this.angularFilterHelperService.translate('Services.Other.Proceed_To_Accept'),
						onClick: () =>
							this.angularRoutingHelperService.setPath('/bookings/requests')
					});
				}

				this.store.REQUESTS = newRequests;
				deferred.resolve(newRequests);
			},
			() => {
				this.store.REQUESTS = [];
				deferred.resolve([]);
			}
		);

		return deferred.promise;
	}

	getBookingRequests() {
		return this.store.REQUESTS;
	}

	markRequestResponded(requestId: number) {
		if (!requestId) return;

		this.serviceRestServices.respondBookingRequest(
			{ requestId },
			() => {
			},
			(err) => {
				console.error('Failed to respond booking request', err);
			}
		);
	}


}